const FILTER_TYPES = {
  text: 'basic',
  select: 'select',
  status: 'select',
  boolean: 'boolean',
  number: 'min_max',
  date: 'date'
}

export const filterableCustomColumnTypes = Object.keys(FILTER_TYPES)

// A custom column dressed as a table column, so the shared filter editors can filter it.
export const customColumnFilterColumn = (customColumn) => {
  const key = `custom_column_${customColumn.id}`
  return {
    id: customColumn.id,
    database_column_name: key,
    accessor_key: key,
    display_name: customColumn.name,
    name: customColumn.name,
    filter_type: FILTER_TYPES[customColumn.column_type] || 'basic',
    is_sortable: true,
    section_abbreviation: 'custom'
  }
}

export const customColumnFilterOptions = (customColumn) => {
  if (customColumn.column_type === 'select' || customColumn.column_type === 'status') {
    return customColumn.settings?.options?.map((option) => ({ value: option, label: option })) || []
  }
  if (customColumn.column_type === 'boolean') {
    return [
      { value: 'true', label: 'Checked' },
      { value: 'false', label: 'Unchecked' }
    ]
  }
  return []
}
